import { FormSelectOption } from '../atoms/FormSelect'
import { MobileReferenceValue } from 'src/redux/mobileReferenceReducer'

interface ReferenceSelectOptionsArgs {
  values: MobileReferenceValue[]
  labelForCode: (code: string) => string
  currentCode: string
}

export const referenceSelectOptions = ({
  values,
  labelForCode,
  currentCode
}: ReferenceSelectOptionsArgs): FormSelectOption[] => {
  const options = values.map((item) => {
    const storedLabel = item.label ?? ''
    return {
      value: item.code,
      label: storedLabel.trim() === '' ? labelForCode(item.code) : storedLabel
    }
  })
  const selected = currentCode.trim()
  if (selected === '' || options.some((option) => option.value === selected)) {
    return options
  }
  return [...options, { value: selected, label: labelForCode(selected) }]
}
